import api from '../api'

export default {
    namespaced: true,
    state: {
        branchDetails: null
    },
    actions: {
        getBranchDetails({commit}, id) {
            commit('showLoading', null, {root: true})
            api.branches.getBranch(id).then(branchDetails => {
                commit('setBranchDetails', branchDetails)
                commit('hideLoading', null, {root: true})

            })
        }
    },
    mutations: {
        setBranchDetails(state, branchDetails) {
            state.branchDetails = branchDetails;
        }
    },
    getters: {
        branchDetails: s => s.branchDetails
    }

}
